import React, { useCallback, useMemo, useState } from 'react'
import { makeStyles } from '@material-ui/core'
import { Button, Modal, PageTitle } from '../root/components/common'
import { useDispatch, useSelector } from 'react-redux'
import { CommentCard } from './partials'
import { REPORT_TYPES } from '../root/hooks/useReportTypes'
import { replaceReportType } from './api/report-api'
import { enqueueSnackbar } from '../root/actions'

/* eslint-disable */
const useStyles = makeStyles(theme => ({
    root: {
        maxHeight: '90vh',
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column'
    },
    pageTitle: {
        marginBottom: 40
    },
    btnsWrapper: {
        marginTop: 20,
        display: 'flex',
        justifyContent: 'flex-end'
    }
}))

export const ReportReplaceTypeModal = ({
    onClose,
    open,
    reportId,
    replaceType,
    reloadReport
}) => {
    const dispatch = useDispatch()
    const classes = useStyles()

    const locale = useSelector(state => state.main.locale)
    const theme = useSelector(state => state.main.theme)

    const [commentText, setCommentText] = useState('')
    const [imagesForUpload, setImagesForUpload] = useState([])
    const [deletedPictureKeys, setDeletedPictureKeys] = useState([])

    const title = useMemo(() => {
        if (replaceType === REPORT_TYPES.false_triggering) {
            return locale.reports.changeRTToFT
        }
        if (replaceType === REPORT_TYPES.catch) {
            return locale.reports.changeRTToCatch
        }
        return ''
    }, [locale, replaceType])

    const description = useMemo(() => {
        if (replaceType === REPORT_TYPES.false_triggering) {
            return locale.reports.changeRTToFTDescr
        }
        if (replaceType === REPORT_TYPES.catch) {
            return locale.reports.changeRTToCatchDescr
        }
        return ''
    }, [locale, replaceType])

    const handleConfirm = useCallback(async () => {
        try {
            await replaceReportType(
                reportId,
                commentText,
                imagesForUpload,
                replaceType
            )
            onClose()
            dispatch(
                enqueueSnackbar({
                    message: locale.common.success,
                    options: {
                        variant: 'success'
                    }
                })
            )
            reloadReport()
        } catch (error) {
            console.log(error)
            dispatch(
                enqueueSnackbar({
                    message: locale.sagasMsgs.commonLoadingError,
                    options: {
                        variant: 'error'
                    }
                })
            )
        }
    }, [
        reportId,
        commentText,
        imagesForUpload,
        replaceType,
        onClose,
        reloadReport,
        locale
    ])

    const handleCancel = useCallback(() => {
        onClose()
    }, [onClose])

    const isConfirmButtonDisabled = useMemo(() => {
        return commentText.trim().length === 0
    }, [commentText])

    return (
        <Modal
            size="md"
            onClose={handleCancel}
            open={open}
            className={classes.root}
        >
            <PageTitle
                title={title}
                className={classes.pageTitle}
                wrapTitle={true}
            />
            <p>{description}</p>
            <div
                style={{
                    fontSize: 10,
                    color: theme.textSecondary,
                    marginBottom: -10
                }}
            >
                *{locale.common.required}
            </div>
            <CommentCard.NewComment
                addComment={true}
                commentId={null}
                setCommentText={setCommentText}
                commentText={commentText}
                locale={locale}
                imagesForUpload={imagesForUpload}
                setImagesForUpload={setImagesForUpload}
                deletedPictureKeys={deletedPictureKeys}
                setDeletedPictureKeys={setDeletedPictureKeys}
                isEdit={true}
                postComment={() => {}}
                report={null}
                setAddComment={() => {}}
                setIsEdit={() => {}}
                isReplaceTypeModal={true}
            />
            <div className={classes.btnsWrapper}>
                <Button
                    style={{ marginRight: 8 }}
                    onClick={handleConfirm}
                    disabled={isConfirmButtonDisabled}
                >
                    {locale.common.confirm}
                </Button>
                <Button reverted onClick={handleCancel}>
                    {locale.common.cancel}
                </Button>
            </div>
        </Modal>
    )
}
/* eslint-enable */
